import { useNavigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { KeyboardBackspace } from "@mui/icons-material";
import LeftGridTemplateStyles from "./LeftGridTemplateStyles";

const LeftGridTemplate = ({ title, subtitle, backUrl }) => {
  const navigate = useNavigate();

  return (
    <LeftGridTemplateStyles>
      <Card className="leftGridCard">
        <CardHeader
          title={
            <Box className="backBox">
              {backUrl && (
                /* Conditional rendering of the back button if backUrl is provided */
                <Box>
                  <Tooltip title="Back">
                    <IconButton
                      aria-label="back"
                      className="back-button"
                      onClick={() => navigate(backUrl)}
                    >
                      <KeyboardBackspace fontSize="large" />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              <Box className="leftGridCardHeader">
                <Box onClick={() => navigate(backUrl)} className="leftGridTitle">
                  <Typography variant="h4">{title}</Typography>
                </Box>
                <Typography variant="p" className="leftGridSubtitle">{subtitle}</Typography>
              </Box>
            </Box>
          }
        />
      </Card>
    </LeftGridTemplateStyles>
  );
};

export default LeftGridTemplate;
